import dialog from "@utils/dialog";
import axios from "axios";
import {WS_Status,Common} from "@utils/constant";

const state = {
    token: null,
    userInfo: null,
    expires_time: null,
    color: '',
    notice: '',
    wsStatus: WS_Status.unconnected,
    messageListeners: [],
    appConfig: null,
    uid: null
};

const mutations = {
    SET_UID(state, id) { // 【新增】
        state.uid = id;
    },
    // 【新增】添加监听器
    ADD_MESSAGE_LISTENER(state, listener) {
        // 防止重复添加同一个函数
        if (!state.messageListeners.includes(listener)) {
            state.messageListeners.push(listener);
        }
    },
    // 【新增】移除监听器
    REMOVE_MESSAGE_LISTENER(state, listener) {
        const index = state.messageListeners.indexOf(listener);
        if (index !== -1) {
            state.messageListeners.splice(index, 1);
        }
    },
    upLiveNotice(state, notice) {
        state.notice = notice
    },
    upWsStatus(state, status) {
        state.wsStatus = status
    },
    SHOW_FOOTER(state) {
        state.footer = true;
    },
    HIDE_FOOTER(state) {
        state.footer = false;
    },
    SHOW_HOME(state) {
        state.home = true;
    },
    HIDE_HOME(state) {
        state.home = false;
    },
    LOGIN(state,obj) {
        // console.log('uid-----------:',obj.uid);
        // console.log('token-----------:',obj.token);
        // console.log('expires_time-----------:',obj.expires_time);
        state.uid = obj.uid;
        state.token = "Bearer "+obj.token;
        state.expires_time = obj.expires_time;
    },
    LOGOUT(state) {
        state.token = null;
        state.expires_time = null;
        state.uid = null; // 【新增】登出时清空
    },
    BACKGROUND_COLOR(state, color) {
        state.color = color;
        document.body.style.backgroundColor = color;
    },
    UPDATE_USERINFO(state, userInfo) {
        state.userInfo = userInfo;
    },
    UPDATE_APP_CONFIG(state, config) {
        state.appConfig = config;
    }
};

const actions = {
    // 【核心新增】分发消息事件
    broadcastMessage({ state, commit }, msg) {
        console.log('收到的消息:',JSON.stringify(msg));
        // 使用 [...state.messageListeners] 进行浅拷贝遍历，防止在遍历过程中数组被修改导致的问题
        const listeners = [...state.messageListeners];
        listeners.forEach(listener => {
            try {
                // 直接调用组件传进来的方法，把 msg 传过去
                listener(msg);
            } catch (error) {
                console.error('监听器执行出错:', error);
            }
        });
        // 注意：这里不需要 commit('executeAction')，因为不依赖 state 的 0/1 切换来触发
    },
    login({ commit }, uid) {
        // commit("LOGIN",uid, Common.Token, 100000);
        return new Promise((resolve, reject) => {
            axios
                .post(
                    "/h5Login",
                    {
                        uid: uid,
                    }
                )
                .then((res) => {
                    // const { uid, token, expires_time } = res.data;
                    console.log('登录接口返回数据:', res.data);
                    // 请求成功后再提交 mutation
                    commit("LOGIN", res.data);
                    resolve(res.data);
                })
                .catch((e) => {
                    reject(e);
                });
        });
    },
    getAppConfig({ state, commit }) {
        return new Promise((resolve, reject) => {
            // 如果已经有缓存了，直接返回缓存数据，不再发请求
            if (state.appConfig) {
                resolve(state.appConfig);
                return;
            }

            // 没有缓存则发起请求
            axios.get("/gatherIndex/getAppConfig")
                .then((res) => {
                    const configData = res.data;
                    // 存入 Vuex
                    commit("UPDATE_APP_CONFIG", configData);
                    resolve(configData);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    USERINFO({commit}) {
        return new Promise((resolve) => {
            axios.get("/userInfo", {}).then((res) => {
                commit("UPDATE_USERINFO", res.data);
                resolve(res.data);
            });
        }).catch(() => {
            dialog.error("获取信息失败!");
        });
    },
};

export default {
    state,
    mutations,
    actions,
};
